import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { PasswordInput } from "@/components/auth/PasswordInput";

const input = "w-full border border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:border-gold";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (pw.length < 6) errs.pw = "Minimo 6 caratteri";
    if (confirm !== pw) errs.confirm = "Le password non coincidono";
    setErr(errs);
    if (Object.keys(errs).length) return;
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, newPassword: pw });
      toast.success("Password aggiornata, ora puoi accedere");
      nav("/login");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr({ general: typeof d === "string" ? d : "Link non valido o scaduto" });
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-6 py-16 text-center">
        <p className="text-slate-600">Link non valido.</p>
        <Link to="/password-dimenticata" className="btn-pill-gold inline-flex mt-4">Richiedi un nuovo link</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <span className="overline text-gold">Nuova password</span>
      <h1 className="font-display text-3xl font-bold mt-2 mb-6 flex items-center gap-2"><KeyRound className="w-7 h-7 text-gold" />Imposta la nuova password</h1>
      <form onSubmit={submit} noValidate className="space-y-4">
        <div>
          <label className="overline text-slate-500 mb-2 block">Nuova password</label>
          <PasswordInput testId="reset-password" value={pw} onChange={(e) => setPw(e.target.value)} className={`${input} ${err.pw ? "field-error" : ""}`} />
          {err.pw && <div className="field-error-text">{err.pw}</div>}
        </div>
        <div>
          <label className="overline text-slate-500 mb-2 block">Conferma password</label>
          <PasswordInput testId="reset-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={`${input} ${err.confirm ? "field-error" : ""}`} />
          {err.confirm && <div className="field-error-text">{err.confirm}</div>}
        </div>
        {err.general && (
          <div className="field-error-text" data-testid="reset-error">
            {err.general}. <Link to="/password-dimenticata" className="underline">Richiedi un nuovo link</Link>
          </div>
        )}
        <button data-testid="reset-submit" disabled={loading} className="btn-pill-gold w-full justify-center">{loading ? "Salvataggio…" : "Salva nuova password"}</button>
      </form>
    </div>
  );
}
